module.exports = __webpack_public_path__ + "static/media/blog17.7aad0fa2.svg";